import React, { useState, useEffect, useRef } from "react";
import {
  Layout,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import MainLayout from "../../../../components/layouts/MainLayout";
import definedApi from "../../../../services/definedApi";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../../components/layouts/TopContent";
import {
  salesTransactionApi,
  salesTransactionLabel,
  salesTransactionStatic,
} from "./fxTransactionSales.config";

import { rightAction } from "../../../../redux/actions";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import appStatic from "../../../../config/appStatic";

//global distructures
const { Text, Link, Title } = Typography;
const Search = Input;
const { manageSalesTransactionItems, monthList } = salesTransactionStatic;

const columns = [
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
  },
  {
    title: "Account No",
    dataIndex: "accountNo",
  },
  {
    title: "Account Holder",
    dataIndex: "accountHolder",
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
  {
    title: "Currency",
    dataIndex: "currency",
  },
  {
    title: "Account Currency Amount",
    dataIndex: "accountCurrencyAmount",
  },
  {
    title: "Local Currency Amount",
    dataIndex: "localCurrencyAmount",
  },
];

const ManageTransactionSales = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const {
    userData,
    // onSelectItemAction,
    rightBtn,
    rightAction,
  } = props;
  const { session } = userData;
  const [salesTransactionList, setSalesTransactionList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const [rightViewBtn, setRightViewBtn] = useState("default");
  const dispatch = useDispatch();

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();
    // console.log(searchKey);

    if (!searchKey) {
      setSalesTransactionList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.accountNo?.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    setSalesTransactionList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED

  useEffect(() => {
    //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    rightAction(cnt.RIGHT_ADD_BTN);

    getSalesTransaction();
  }, []);

  const getSalesTransaction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      salesTransactionApi.salesTransaction,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          setIsLoading(false);
        } else {
          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              transactionDate: element?.transactionDate
                ? `${element?.transactionDate[2]} ${
                    monthList[element?.transactionDate[1] - 1]
                  } ${element?.transactionDate[0]}`
                : "-",
              accountNo: element?.savingsAccountNo
                ? element?.savingsAccountNo
                : "-",
              accountHolder: element?.customerName
                ? element?.customerName
                : "-",
              amount: element.transactionAmount
                ? element.transactionAmount
                : "-",
              currency: element.transactionCurrencyCode
                ? element.transactionCurrencyCode
                : "-",
              accountCurrencyAmount: element.accountCurrencyAmount
                ? element.accountCurrencyAmount
                : "-",
              localCurrencyAmount: element.localCurrencyAmount
                ? element.localCurrencyAmount
                : "-",
            });
          });

          setSalesTransactionList(tempArray);

          //keep the orginal data to use after gList is modified when change from autorise to disable
          setOriginalList(tempArray);

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(
        body,
        salesTransactionApi.salesTransaction,
        (err, res) => {
          if (err) {
            reject(err);
          } else {
            const objList = res.pageItems;
            let tempArray = [];

            objList.forEach((element) => {
              tempArray.push({
                key: element?.id,
                id: element?.id,
                transactionDate: element?.transactionDate
                  ? `${element?.transactionDate[2]} ${
                      monthList[element?.transactionDate[1] - 1]
                    } ${element?.transactionDate[0]}`
                  : "-",
                accountNo: element?.savingsAccountNo
                  ? element?.savingsAccountNo
                  : "-",
                accountHolder: element?.customerName
                  ? element?.customerName
                  : "-",
                amount: element.transactionAmount
                  ? element.transactionAmount
                  : "-",
                currency: element.transactionCurrencyCode
                  ? element.transactionCurrencyCode
                  : "-",
                accountCurrencyAmount: element.accountCurrencyAmount
                  ? element.accountCurrencyAmount
                  : "-",
                localCurrencyAmount: element.localCurrencyAmount
                  ? element.localCurrencyAmount
                  : "-",
              });
            });

            resolve(tempArray);
          }
        }
      );
    });
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-transaction-sales", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-transaction-sales", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
    >
      <TopContent
        pageTitle={salesTransactionLabel.manageSalesTransaction}
        pageItems={manageSalesTransactionItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"FX Sales Transactions"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by FX Account No..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={salesTransactionList}
              columns={columns}
              fileName={"FX Sales Transaction List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={salesTransactionList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageTransactionSales);
